import { Form, InputNumber, Modal } from 'antd';
import { message } from '@/components/Message';
import React, { useEffect, useState } from 'react';
import api from '../../api';

type Props = {
  open: boolean;
  onClose: () => void;
};
const PoiSelectModal: React.FC<Props> = ({ open, onClose }: Props) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(open);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setVisible(open);
  }, [open]);

  const onSubmit = ({ eId }) => {
    setLoading(true);
    api
      .post({
        url: `/admin/switchPoi/${eId}`,
      })
      .then(() => {
        window.location.reload();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.msg);
      });
  };
  return (
    <Modal
      title="商家视角"
      open={visible}
      destroyOnHidden
      okButtonProps={{ loading: loading }}
      onCancel={() => {
        setVisible(false);
      }}
      afterClose={onClose}
      onOk={() => {
        form.submit();
      }}>
      <Form form={form} layout="horizontal" onFinish={onSubmit}>
        <Form.Item name="eId" label="商家 id" extra={'-1 退出'} rules={[{ required: true }]}>
          <InputNumber min={-1} precision={0} placeholder={'ID'} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PoiSelectModal;
